var IMAGE_PATH = {
  'luminate-purple-icon': 'https://i5.walmartimages.com/dfw/63925b23-7d93/k2-_2b815249-6060-47b5-a087-826eadf66deb.v1.png',
  'walmart-luminate-purple-logo': 'https://i5.walmartimages.com/dfw/63925b23-527e/k2-_fe57c0dd-fb8a-436f-b42c-c079100359ad.v1.png',
  'scintilla-purple-logo': 'https://i5.walmartimages.com/dfw/63925b23-6e51/k2-_6fadde78-c6dc-429c-a944-67e93251cfa5.v1.png',
  'scintilla-white-logo': 'https://i5.walmartimages.com/dfw/63925b23-b136/k2-_2b5b0bfb-b017-4f73-9029-6e2e68658e78.v1.png'
};

export { IMAGE_PATH };
